export enum GridSelectionMode {
    Cell = "Cell",
    Row = "Row"
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/objects/enums/grid-selection-mode.ts